import React, { useState, useEffect } from 'react';
import { startCase } from 'lodash';
import { Table, PageTitle } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';

import { fetchAvailableTypes } from '~/utils/situation-tables/reference-data-api';

const columns = [{
  id: 'name',
  Header: 'Name',
  accessor: (type) => startCase(type.key.replace(/_/g, ' ')),
  filterMethod: (filter, row) =>
    row[filter.id].toLowerCase().includes(filter.value.toLowerCase()),
}, {
  id: 'tableName',
  Header: 'Table',
  accessor: 'table_name',
}];

const defaultSorted = [{
  id: 'name',
}];

const SitReferenceDataTypes = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAvailableTypes()
      .then((response) => response.data)
      .then((types) => {
        // Transform the object into an array with keys
        const typesArray = Object.entries(types).map(([key, value]) => ({
          key,
          ...value,
        }));
        setData(typesArray);
      })
      .catch((error) => {
        console.error('Error fetching reference data types:', error);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <PageTitle>Situation Tables Reference Data</PageTitle>

      <Table
        data={data}
        columns={columns}
        loading={loading}
        defaultSorted={defaultSorted}
        filterable
        getTrProps={(state, rowInfo) => ({
          style: {
            cursor: 'pointer',
          },
          onClick: (e, handleOriginal) => (
            handleOriginal
              ? handleOriginal()
              : history.push(`/toolbox/sit-reference-data/${rowInfo.original.key}`)
          ),
        })}
      />
    </>
  );
};

export default SitReferenceDataTypes;
